import { createStyles, makeStyles, Theme } from '@material-ui/core';

const usePhoneDialogStyles = makeStyles(({ palette, colors, spacing, breakpoints }: Theme) => createStyles({
  dialogHeader: {
    paddingTop: 32,
    paddingRight: 24,
    paddingLeft: 24,
  },
  title: {
    fontSize: 24,
    fontFamily: 'Montserrat',
    [breakpoints.down('xs')]: {
      fontSize: 20,
    },
    '@media(max-width: 320px)': {
      fontSize: 17,
    },
  },

  dialogContentWrapper: {
    paddingBottom: 90,
  },

  contentMessage: {
    marginTop: 40,
    marginBottom: 40,
    [breakpoints.down('xs')]: {
      marginTop: 24,
    },
  },

  cancelButton: palette.cancelAction,

  panelButton: {
    height: '36px',
    minWidth: '128px',

    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
  },
  closeButton: {
    padding: 0,
    fontSize: '1.6em',
    color: '#747C99',
  },
  closeIcon: {
    fontSize: '2rem',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  labelRoot: {
    '&$focused': {
      color: palette.text.secondary,
    },
  },
}), { name: 'SetupPhoneDialog' });

export default usePhoneDialogStyles;
